const BASE_URL = 'https://api.themoviedb.org/3/';
const API_KEY_PARAM = '?api_key=a32dbede8c11efa49e0669411d37b6f0';
const BACKDROP_BASE_URL = 'https://image.tmdb.org/t/p/original/';
const SMALL_IMG_COVER_BASE_URL = "https://image.tmdb.org/t/p/w300/";
export { BASE_URL, API_KEY_PARAM, BACKDROP_BASE_URL, SMALL_IMG_COVER_BASE_URL };
